import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../global/components/ThreeDotMenu";

export const groupColumns = ["actions", "name", "userCount", "ruleCount", "plugins"];
export const ssoAndScimEnabledGroupColumns = ["actions", "name", "userCount", "ruleCount", "idpGroups", "plugins"];

export const getGroupManagementColumns = (
	loading,
	openResourceEditPage,
	navigationItemReferences,
	duplicateGroup,
	handleToggleGroupDeleteDialog,
	identityProviderName,
	organizationSsoAndScim
) => [
	{
		field: "name",
		headerName: "Name",
		sortable: true,
		editable: false,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "userCount",
		headerName: "Total Users",
		editable: false,
		sortable: false,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.value} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "ruleCount",
		headerName: "Total Rules",
		editable: false,
		sortable: false,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "plugins",
		headerName: "Plugins",
		editable: false,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridListCell items={params.value} resource="Plugins" />
				}
				isLoading={loading}
			/>
		),
	},
	...(organizationSsoAndScim
		? [
			{
				field: "idpgroups",
				headerName: identityProviderName ? `${identityProviderName} Groups` : "Groups",
				editable: false,
				sortable: false,
				flex: 1,
				renderCell: (params) => (
					<CoAppDataGridSkeletonCell
						cellToRender={<CoAppDataGridListCell items={params.value} resource={identityProviderName ? `${identityProviderName} Groups` : "Groups"} />}
						isLoading={loading}
					/>
				),
			},
		]
		: []),
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						<ThreeDotMenu
							options={[
								{
									name: "Edit",
									optionClickHandler: () => {
										openResourceEditPage(params, navigationItemReferences.groupNavItemIndex, "Groups");
									},
								},
								{
									name: "Duplicate",
									optionClickHandler: () => {
										duplicateGroup(params.row.id);
									},
								},
								{
									name: "Delete",
									optionClickHandler: () => {
										handleToggleGroupDeleteDialog(params.row);
									},
								},
							]}
						/>
					</div>
				}
				isLoading={loading}
			/>
		),
	}
];